import { IElementCategory } from '@shared/models/element-categories.model';
import { IConditionalNode } from '../../../helpers/conditional-nodes.helpers';
import {
  ElementPropertyType,
  IFactoryProperty,
  IFactorySelectProperty,
  IFactorySwitchProperty,
} from '../../../models/element-property.model';
import { reusedContentProperty } from '../reused-content-property.model';
import {
  Wool,
  HempFibre,
  InsulationMaterial,
  InsulationPropertyName,
  InsulationSpecialPropertyName,
  StoneWool,
  WoodFibre,
  CelluloseFibre,
} from './insulation.model';
import { commonElementCategoryProperties } from '../common-element-category-properties.model';

// const insulationThermalConductivityProperty: IFactoryExpressionProperty = {
//   name: InsulationPropertyName.conductivity,
//   unit: 'W/mK',
//   fallbackCount: 0.035,
//   // TODO, show when EPS or XPS is calculated using this value
//   hidden: true,
// };

const insulationMaterialProperty: IFactorySelectProperty = {
  name: InsulationPropertyName.material,
  type: ElementPropertyType.Select,
  count: InsulationMaterial.StoneWool,
  options: Object.values(InsulationMaterial),
};

const celluloseFibreConditionalProperty: IConditionalNode<IFactorySelectProperty> =
  {
    conditions: {
      [InsulationPropertyName.material]: InsulationMaterial.CelluloseFibre,
    },
    nodes: [
      {
        name: InsulationPropertyName.form,
        type: ElementPropertyType.Select,
        options: Object.values(CelluloseFibre),
        indentation: 1,
      },
    ],
  };

const hempFibreConditionalProperty: IConditionalNode<IFactorySelectProperty> = {
  conditions: {
    [InsulationPropertyName.material]: InsulationMaterial.HempFibre,
  },
  nodes: [
    {
      name: InsulationPropertyName.form,
      type: ElementPropertyType.Select,
      options: Object.values(HempFibre),
      indentation: 1,
    },
  ],
};

const battsAndRollsConditionalProperty: IConditionalNode<IFactorySwitchProperty> =
  {
    conditions: {
      [InsulationPropertyName.form]: Wool.BattsAndRolls,
    },
    nodes: [
      {
        name: InsulationSpecialPropertyName.SoundBatts,
        type: ElementPropertyType.Switch,
        indentation: 1,
      },
    ],
  };

const glassWoolConditionalProperty: IConditionalNode<IFactoryProperty> = {
  conditions: {
    [InsulationPropertyName.material]: InsulationMaterial.GlassWool,
  },
  nodes: [
    {
      name: InsulationPropertyName.form,
      type: ElementPropertyType.Select,
      options: Object.values(Wool),
      indentation: 1,
    },
    battsAndRollsConditionalProperty,
  ],
};

const stoneWoolConditionalProperty: IConditionalNode<IFactorySelectProperty> = {
  conditions: {
    [InsulationPropertyName.material]: InsulationMaterial.StoneWool,
  },
  nodes: [
    {
      name: InsulationPropertyName.form,
      type: ElementPropertyType.Select,
      options: [...Object.values(Wool), ...Object.values(StoneWool)],
      indentation: 1,
    },
  ],
};

const woodFibreConditionalProperty: IConditionalNode<IFactorySelectProperty> = {
  conditions: {
    [InsulationPropertyName.material]: InsulationMaterial.WoodFibre,
  },
  nodes: [
    {
      name: InsulationPropertyName.form,
      type: ElementPropertyType.Select,
      options: Object.values(WoodFibre),
      indentation: 1,
    },
  ],
};

export const insulationProperties: IElementCategory['properties'] = [
  insulationMaterialProperty,
  celluloseFibreConditionalProperty,
  hempFibreConditionalProperty,
  glassWoolConditionalProperty,
  stoneWoolConditionalProperty,
  woodFibreConditionalProperty,
  reusedContentProperty,
  ...commonElementCategoryProperties,
];
